<mat-toolbar class="aca-toolbar">
  <ng-container *ngFor="let item of items; trackBy: trackByActionId">
    <aca-toolbar-action [actionRef]="item" />
  </ng-container>
</mat-toolbar>
